/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-08-03 11:28:34
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-08-03 12:14:12
 * @FilePath: \xm-operate-account\src\stores\global-user-info.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defHttp } from 'xmgoing-server'
import {StorageUtils} from 'xmgoing-utils'

export const useGlobalUserInfoStore = defineStore('global-user-info', () => {
  const loading = ref(false)
  const userInfo = ref<Record<string, any>>({})

  async function getUserInfo () {
    if (loading.value) {
      return
    }
    loading.value = true
    try {
      const res = await defHttp.post({
        url: '/pe-portal/account/getCurAccountInfo'
      })
      userInfo.value = res
      StorageUtils.addSessionItem('curAccountInfo', JSON.stringify(res))
    } finally {
      loading.value = false
    }
  }

  onMounted(() => {
    getUserInfo()
  })

  return {
    userInfo,

    refreshUserInfo: getUserInfo
  }
})
